
<div class="labels-statistics-container ob-scroll">
  <div class="row statistics-filters">
    <div class="col-sm-6 col-md-3 pb-2">
      <div>From</div>
      <board-item-date-picker :mode="'date'" v-model="dateFrom" />
    </div>

    <div class="col-sm-6 col-md-3 pb-2">
      <div>From</div>
      <board-item-date-picker :mode="'date'" v-model="dateTo" />
    </div>
    <div class="col-sm-6 col-md-3 pb-2">
      <div class="cursor-pointer">
        <b-form-checkbox class="mb-1" v-model="useBoardLabelsOnly" :unchecked-value="false">
          Only show board-specific labels
        </b-form-checkbox>
      </div>
    </div>
  </div>

  <div class="actions">
    <div>
      <button class="badgebutton active btn" @click="refreshLabelsStatistic" :disabled="!dateFrom || !dateTo">
        <i class="fa fa-sync"></i>
        Refresh Statistics
      </button>
    </div>
    <div>
      <button class="badgebutton active btn" @click="loadLabelsStatistic" :disabled="!dateFrom || !dateTo">
        <i class="fa fa-download"></i>
        Load Statistics
      </button>
    </div>
  </div>

  <div v-if="!displayEmptyResult" class="container-fluid">
    <div class="row">
      <div class="col-sm-12 col-md-6" v-if="pieStatisticValues && pieStatisticValues.length">
        <div class="pie-statistic">
          <div class="pie-statistic-header">Top {{ pieStatisticValues.length }} used labels</div>
          <apexchart
            :type="pieStatisticOptions.chart.type"
            :width="pieStatisticOptions.chart.width"
            :options="pieStatisticOptions"
            :series="pieStatisticValues"
          ></apexchart>
        </div>

        <hr class="mt-3" />
        <div class="labels-usage">
          <div class="labels-usage-header labels-usage-row">
            <div>Label</div>
            <div>Used in Time Range</div>
          </div>
          <div class="labels-usage-row" v-for="(item, index) in allLabelsUsageStatistics" :key="index">
            <div>{{ item.labelTitle }}</div>
            <div>{{ item.usedCount }}</div>
          </div>
        </div>
        <hr />
      </div>

      <div class="col-sm-12 col-md-6" v-if="barStatisticValues && barStatisticValues.length">
        <apexchart
          :type="barStatisticOptions.chart.type"
          :height="barStatisticOptions.chart.height"
          :options="barStatisticOptions"
          :series="barStatisticValues"
        ></apexchart>
      </div>
    </div>
  </div>

  <div v-if="displayEmptyResult" class="p-12">
    <div class="label justify-content-center d-flex align-items-center">
      <i class="far fa-search fa-2x mr-2"></i>
      No Board labels usage found, please modify your query
    </div>
  </div>
</div>
